"use strict";
import getters from './getters';
import actions from './actions';

export default {
    namespaced: true,
    state: () => ({
        _headerBreadcrumbs: [],
    }),
    getters,
    actions,
};
